import { props, state } from 'cerebral/tags'
import { set, when, equals } from 'cerebral/operators'
import editMedia from '../actions/editMedia'
import addResource from './addResource'
import createSnackbar from 'modules/App/factories/createSnackbar'
import getCurrentMediaId from '../actions/getCurrentMediaId'
import addRestrictionMessage from './addRestrictionMessage'

export default [
  when(state`media.tags.showShared`),
  {
    true: [
      equals(props`type`),
      {
        restriction: [...addRestrictionMessage],
        otherwise: [...addResource]
      }
    ],
    false: [
      getCurrentMediaId,
      equals(props`type`),
      {
        name: [
          set(state`media.files.${props`id`}.name`, props`value`),
          editMedia,
          function({ state, props }) {
            const path = state.get(`media.currentFile`)
            const file = state.get(path)
            if (file.relativePath) {
              const index = file.relativePath.lastIndexOf('/')
              // remove /
              const subPath = file.relativePath.substr(
                index + 1,
                file.relativePath.length
              )

              state.set(
                `${path}.relativePath`,
                file.relativePath.replace(subPath, props.value)
              )
            }
          },
          createSnackbar({ key: 'bms.fieldSaved' }, 'success')
        ],
        caption: [
          set(state`media.files.${props`id`}.metaData.caption`, props`value`),
          editMedia,
          createSnackbar({ key: 'bms.fieldSaved' }, 'success')
        ],
        receivers: [
          function({ uuid, state, props }) {
            state.set(`basket.receivers.tags.${uuid.id()}`, {
              label: props.value,
              selected: true
            })
          },
          set(state`basket.receivers.form.value`, ''),
          set(state`basket.receivers.form.isPristine`, true)
        ],
        restriction: [...addRestrictionMessage],
        otherwise: [...addResource]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/saveMetaField.js